import { FC, useEffect, useState } from "react";
import "./SidebarSubscriptionsFilter.scss";
import SidebarFilter from "../../../SidebarFilter/SidebarFilter";
import { useForm } from "react-hook-form";
import { Col, FormGroup, Row } from "react-bootstrap";
import ReactSelect from "react-select";
import { customStyles } from "../../../../models/SelectCustomStyles";
import { useSubscriptions } from "../../../../providers/Financial/Subscriptions/SubscriptionsProvider";
import { PlansService } from "../../../../services/Financial/Plans/PlansServices";
import { CouponsService } from "../../../../services/Financial/Coupons/CouponsServices";
import { SubscriptionsService } from "../../../../services/Financial/Subscriptions/SubscriptionsServices";
import InputSearchPartner from "../../../InputSearchPartner/InputSearchPartner";

interface SidebarSubscriptionsFilterProps {}

// @ts-ignore
export const defaultValues = {
  user: "",
  plan_id: "",
  plan_coupon_id: "",
  plan_subscription_status_id: "",
} as any;

const SidebarSubscriptionsFilter: FC<SidebarSubscriptionsFilterProps> = () => {
  const [valuePartner, setValuePartner] = useState<string>("");
  const [selectedPlan, setSelectedPlan] = useState<any>("");
  const [selectedCoupon, setSelectedCoupon] = useState<any>("");
  const [selectedStatus, setSelectedStatus] = useState<any>("");
  const [planOptions, setPlanOptions] = useState<any[]>([]);
  const [couponOptions, setCouponOptions] = useState<any[]>([]);
  const [statusOptions, setStatusOptions] = useState<any[]>([]);

  const { setParams } = useSubscriptions();
  const { handleSubmit, setValue, control } = useForm<any>({ defaultValues });

  useEffect(() => {
    const loadOptions = async () => {
      const plansService = new PlansService();
      const couponsService = new CouponsService();
      const subscriptionsService = new SubscriptionsService();

      const [plansRes] = await plansService.list({ withPaginate: false });
      const plansItems = plansRes?.data?.items || plansRes?.data || [];
      if (plansItems?.length > 0) {
        setPlanOptions([
          { value: "", label: "Todos" },
          ...plansItems.map((p: any) => ({ value: p.id, label: p.name })),
        ]);
      }

      const [couponsRes] = await couponsService.list({ withPaginate: false });
      const couponsItems = couponsRes?.data?.items || couponsRes?.data || [];
      if (couponsItems?.length > 0) {
        setCouponOptions([
          { value: "", label: "Todos" },
          ...couponsItems.map((c: any) => ({ value: c.id, label: c.identifier })),
        ]);
      }

      const [statusRes] = await subscriptionsService.listStatus({ withPaginate: false });
      const statusItems = statusRes?.data?.items || statusRes?.data || [];
      if (statusItems?.length > 0) {
        setStatusOptions([
          { value: "", label: "Todos" },
          ...statusItems.map((s: any) => ({ value: s.id, label: s.name })),
        ]);
      }
    };

    loadOptions();
  }, []);

  const onSubmit = async (data: any) => {
    const filter = {
      user_id: data?.user?.value || null,
      plan_id: data?.plan_id || null,
      plan_coupon_id: data?.plan_coupon_id || null,
      plan_subscription_status_id: data?.plan_subscription_status_id || null,
    };

    setParams((prev: any) => ({
      ...prev,
      filter: { ...(prev?.filter ?? {}), ...filter },
      page: 1,
      perPage: prev?.perPage ?? 10,
      withPaginate: prev?.withPaginate ?? true,
    }));
  };

  return (
    <SidebarFilter handleSubmit={handleSubmit(onSubmit)}>
      <div
        className="SidebarSubscriptionsFilter"
        data-testid="SidebarSubscriptionsFilter"
      >
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label>USUÁRIO</label>
              <InputSearchPartner
                name="user"
                control={control}
                setValue={setValue}
                valuePartner={valuePartner}
                setValuePartner={setValuePartner}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label htmlFor="plan_id">PLANO</label>
              <ReactSelect
                isSearchable
                options={planOptions}
                value={selectedPlan ?? ""}
                defaultValue={selectedPlan}
                placeholder="Selecione..."
                className={`form-control p-0`}
                noOptionsMessage={() => "Não há registros"}
                styles={customStyles}
                onChange={(val: any) => {
                  setValue("plan_id", val?.value);
                  setSelectedPlan(val);
                }}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label htmlFor="plan_coupon_id">CUPOM</label>
              <ReactSelect
                isSearchable
                options={couponOptions}
                value={selectedCoupon ?? ""}
                defaultValue={selectedCoupon}
                placeholder="Selecione..."
                className={`form-control p-0`}
                noOptionsMessage={() => "Não há registros"}
                styles={customStyles}
                onChange={(val: any) => {
                  setValue("plan_coupon_id", val?.value);
                  setSelectedCoupon(val);
                }}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label htmlFor="plan_subscription_status_id">STATUS PAGAMENTO</label>
              <ReactSelect
                isSearchable
                options={statusOptions}
                value={selectedStatus ?? ""}
                defaultValue={selectedStatus}
                placeholder="Selecione..."
                className={`form-control p-0`}
                noOptionsMessage={() => "Não há registros"}
                styles={customStyles}
                onChange={(val: any) => {
                  setValue("plan_subscription_status_id", val?.value);
                  setSelectedStatus(val);
                }}
              />
            </FormGroup>
          </Col>
        </Row>
      </div>
    </SidebarFilter>
  );
};

export default SidebarSubscriptionsFilter;
